<template>
  <router-view
    :types-with-assets="typesWithAssets"
  />
</template>

<script>

export default {
  props: {
    typesWithAssets: Array,
  },
};
</script>

<style lang="sass" scoped>
@page
  margin-bottom: 10mm
</style>
